import { createFileRoute } from '@tanstack/react-router';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { AiAgentsSettingsPage } from '@/features/ai-agents/AiAgentsSettingsPage';

export const Route = createFileRoute('/_authenticated/ai-analysis/agents')({
  component: AiAgentsSettingsRoute,
});

function AiAgentsSettingsRoute() {
  return (
    <PermissionGate permission={Permission.AI_AGENTS_USE}>
      <AiAgentsSettingsPage />
    </PermissionGate>
  );
}
